import React from 'react';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
//style
import './industry.styl';
//images
import auto_white from '../../media/industry/aircheckr-auto-white.png';
import ho_white from '../../media/industry/aircheckr-h&o-white.png';
import health_white from '../../media/industry/aircheckr-health-white.png';
import info_white from '../../media/industry/aircheckr-info-white.png';
import intelli_white from '../../media/industry/aircheckr-intelli-white.png';
import outdoor_white from '../../media/industry/aircheckr-outdoor-white.png';
//text
import { IndustrySmallText as IndustrySmallTextEN } from '../../input-text/en/landing_page';
import { IndustrySmallText as IndustrySmallTextNL  } from '../../input-text/nl/landing_page';

class IndustrySmall extends React.Component {
  constructor(props){
    super(props);
    //state will decide which color
    this.state = {opacity: 'opaque'};
    //choose correct industry
    this.industry = props.industry;
    //pick the icon
    this.catalog = {
      auto: auto_white,
      ho:  ho_white,
      health: health_white,
      info: info_white,
      intelli: intelli_white,
      outdoor: outdoor_white,
    }
    //bind methods
    this.saturate = this.saturate.bind(this);
    this.desaturate = this.desaturate.bind(this);
    this.setLocale = this.setLocale.bind(this);
  }

  saturate(){
    // this.setState({opacity: 'opaque'});
  }

  desaturate(){
    // this.setState({opacity: 'semi-trans'});
  }

  setLocale(locale) {
      this.IndustrySmallText = null;
      switch (this.props.locale) {
          case 'en':
              this.IndustrySmallText = IndustrySmallTextEN;
              break;
          case 'nl':
              this.IndustrySmallText = IndustrySmallTextNL;
              break;
          default:
              this.IndustrySmallText = IndustrySmallTextEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return (
      <div className='col-sm-2 col-xs-12 industry-icon-container' >
        <div className='col-xs-2 col-sm-6 industry-image-container' >
          <img src={this.catalog[this.industry]} alt={this.industry}
            className={this.state.opacity+' industry-small-icon'} onMouseOver={this.desaturate} onMouseLeave={this.saturate}/>
        </div>
        <div className='col-xs-8 industry-title-container' >
          <p className='title hidden-xs'>{this.IndustrySmallText[this.industry].title}</p>
          <h2 className='title visible-xs'>{this.IndustrySmallText[this.industry].title}</h2>
        </div>
        <div className='hidden-xs col-xs-12 industry-text-container'>
          <p className='body-text'>{this.IndustrySmallText[this.industry].body}</p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(IndustrySmall);



// WEBPACK FOOTER //
// ./src/components/industry/IndustrySmall.js